module.exports = __webpack_public_path__ + "static/media/track-marketing-data.0bc58c66.png";